import React, { useState } from "react";
import profileIc from "../../assets/png/profile-ic.png";
import numberFormat from "../common/number-format";
import ProfileImageModal from "../common/common-preview";

const TransactionsTab = ({
  vendorHistoryList,
  hoveredIndex,
  setHoveredIndex,
}) => {
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState("");
  return (
    <>
      {" "}
      <ProfileImageModal
        show={showProfilePopup}
        onClose={() => setShowProfilePopup(false)}
        imageUrl={selectedProfile}
      />
      <div
        style={{
          display: "flex",
          flex: "10",
          paddingLeft: "16px",
          paddingRight: "16px",
          paddingTop: "16px",
          height: "40px",
          backgroundColor: "#F2F2F2",
        }}
        className="head3 w-100 justify-content-center align-items-center"
      >
        <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor">
          Code
        </p>
        <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor">
          Po
        </p>
        <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor">
          Vendor
        </p>
        <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor">
          Total
        </p>
        <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor">
          Trans Amount
        </p>
        <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor">
          Paid
        </p>
        <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor">
          Balance
        </p>{" "}
        <p
          style={{ width: "127px", flex: "1" }}
          className="fs-13 fw-700 textcolor"
        >
          Status
        </p>
      </div>
      <div>
        {(vendorHistoryList ?? []).map((item, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              flex: "10",
              paddingLeft: "16px",
              paddingRight: "16px",
              backgroundColor: hoveredIndex === index ? "#FAFAFA" : "#FFFFFF",
              borderBottom: "1px solid #D4DDE7",
              cursor: "pointer",
              height: "44px",
            }}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            className="head3 w-100 justify-content-center align-items-center"
          >
            {" "}
            <p
              className="fs-13 fw-500 textcolor"
              style={{
                flex: "1",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                marginTop: "16px",
              }}
              title={item.transaction_id}
            >
              {item.transaction_id ?? "---"}
            </p>
            <p
              className="fs-13 fw-500 textcolor"
              style={{
                flex: "1",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                marginTop: "16px",
              }}
              title={item.po_no}
            >
              {item.po_no ?? "---"}
            </p>
            <p
              className="fs-13 fw-500 textcolor"
              style={{
                flex: "1",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                marginTop: "16px",
              }}
              title={item.vendor_name}
            >
              <img
                key={index}
                src={
                  item.image && item.image.trim() !== ""
                    ? item.image
                    : profileIc
                }
                alt="Profile"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedProfile(
                    item.image && item.image.trim() !== ""
                      ? item.image
                      : profileIc,
                  );
                  setShowProfilePopup(true);
                }}
                className="avatar-item me-1 ms-0"
              />
              {item.vendor_name ?? "---"}
            </p>{" "}
            <p
              className="fs-13 fw-500 textcolor"
              style={{
                flex: "1",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                marginTop: "16px",
              }}
              title={numberFormat(item.total_amount)}
            >
              {numberFormat(item.total_amount) ?? "---"}
            </p>
            <p
              className="fs-13 fw-500 textcolor"
              style={{
                flex: "1",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                marginTop: "16px",
              }}
              title={numberFormat(item.trans_amount)}
            >
              {numberFormat(item.trans_amount) ?? "---"}
            </p>{" "}
            <p
              className="fs-13 fw-500 textcolor"
              style={{
                flex: "1",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                marginTop: "16px",
              }}
              title={numberFormat(item.amount_paid)}
            >
              {numberFormat(item.amount_paid) ?? "---"}
            </p>
            <p
              className="fs-13 fw-500 textcolor"
              style={{
                flex: "1",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                marginTop: "16px",
              }}
              title={numberFormat(item.balance_amount)}
            >
              {numberFormat(item.balance_amount) ?? "---"}
            </p>
            <div
              style={{
                padding: "6px 6px",
                flex: "1",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
              className="d-flex align-items-start justify-content-between "
            >
              {" "}
              <span className="d-flex align-items-center  gap-2">
                <span
                  className="backgroundYellow"
                  style={{
                    width: "10px",
                    height: "10px",
                    borderRadius: "3px",
                    display: "inline-block",
                  }}
                ></span>
                <span className="dropdown-text textcolor fs-13 fw-500">
                  {item.status ?? "-"}
                </span>
                <span className="dropdown-toggle-arrow"></span>
              </span>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default TransactionsTab;
